import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ConversationComponentTypes = {
  MESSAGE: 'message',
  CONFIRMATION_OPTIONS: 'confirmation_options',
  GROUPED_DROPDOWN: 'grouped_dropdown',
  CART: 'cart',
  CATALOG_ITEM: 'catalog_item',
  TEXT: 'text',
  ORDER_CONFIRMATION: 'order_confirmation',
} as const

export type ConversationComponentTypeEnum = Enum<
  typeof ConversationComponentTypes
>
